import type { Editor } from "@tiptap/react";

export const getReadyEditor = (editor: Editor | null): Editor | null => {
  if (!editor || editor.isDestroyed) {
    return null;
  }

  try {
    void editor.view.dom;
    void editor.commands;
    editor.can();
    void editor.extensionManager.extensions;
  } catch {
    return null;
  }

  return editor;
};
